export const stripMarkdown = (text: string = ""): string =>
    text
        .replace(/^#{1,6}\s*/gm, "")
        .replace(/^[*+\-]\s+/gm, "")
        .replace(/\*\*(.*?)\*\*/g, "$1")
        .replace(/\*(.*?)\*/g, "$1")
        .replace(/__(.*?)__/g, "$1")
        .replace(/_(.*?)_/g, "$1")
        .replace(/\[([^\]]+)]\([^)]+\)/g, "$1")
        .replace(/^>\s?/gm, "")
        .replace(/`{1,3}.*?`{1,3}/g, "")
        .replace(/!\[[^\]]*]\([^)]*\)/g, "")
        .replace(/^\s*[\r\n]/gm, "")
        .trim();